import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {ProductBrandService} from '../../../configuration/services/product-brand.service';
import {ProductModelService} from '../../../configuration/services/product-model.service';
import {ProductOperatingSystemService} from '../../../configuration/services/product-operating-system.service';
import {ProductStatusService} from '../../../configuration/services/product-status.service';
import {ProductStorageCapacityService} from '../../../configuration/services/product-storage-capacity.service';
import {ProductTelephoneCompanyService} from '../../../configuration/services/product-telephone-company.service';
import {ProductRamService} from '../../../configuration/services/product-ram.service';
import { ProductService } from '../../../products/services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import {ProductCpuService} from '../../../configuration/services/product-cpu.service';

import { TechnicalserviceService } from '../../../technicalservice/services/technicalservice.service';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';
import { UserService } from '../../../common/services/user.service';

@Component({
  selector: 'app-view-product',
  templateUrl: './view-product.component.html',
  styleUrls: ['./view-product.component.css'],
  providers: [ProductBrandService,ProductModelService,ProductOperatingSystemService,ProductRamService,
    ProductStatusService,ProductStorageCapacityService,ProductTelephoneCompanyService,ProductService,ProductCpuService,
    TechnicalserviceService,PurchaseProductService,RepurchaseProductService,ConsignmentProductService,UserService]
})
export class ViewProductComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productType: number = null;
  brands: any = [];
  subTypes: any = [];
  models: any = [];
  telephoneCompanies: any = [];
  operatingSystems: any = [];
  statuses: any = [];
  storageCapacities: any = [];
  rams: any = [];
  product: any = {};
  cpus: any =[];
  config: any = {'sourceField': ['name']};
  transactionType: any = null;
  purchase: any = {};
  repurchase: any = {};
  consignment: any = {};
  
  constructor(private productBrandService:ProductBrandService, private productModelService:ProductModelService, private productOperatingSystemService:ProductOperatingSystemService,
              private productStatusService:ProductStatusService, private productStorageCapacityService:ProductStorageCapacityService, private productTelephoneCompanyService:ProductTelephoneCompanyService,
              private productRamService:ProductRamService,private productCpuService:ProductCpuService, private route: ActivatedRoute, private router: Router, private productService:ProductService,
              private technicalserviceService:TechnicalserviceService, private purchaseProductService:PurchaseProductService, private repurchaseProductService:RepurchaseProductService,
              private consignmentProductService:ConsignmentProductService, private userService:UserService) { }

  ngOnInit() {
    this.getProductBrands();
    this.getProductModels();
    this.getProductOperatingSystems();
    this.getProductStatuses();
    this.getProductStorageCapacities();
    this.getProductTelephoneCompanies();
    this.getProductRams();
    this.getProductCpus();
    this.sub = this.route.params.subscribe(params => {
        if (params['id'] !== undefined){
         this.id = params['id'];
         this.getProduct();
        }
      });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  getProduct(){
    this.productService.get(this.id).subscribe((product) => {
     this.product = product;
     this.productType = product.type;
     if (product.type == 1){
      this.subTypes =[
        {id:1, name:"Móvil"},
        {id:2, name:"Tablet"}
      ]
    }else if (product.type == 4){
      this.subTypes =[
        {id:1, name:"PC"},
        {id:2, name:"Portatil"}
      ]
    }
     this.getProductIncomingentity();
    });
  }

  //Get entity from product come (Purchase, Repurchase, Consignment, TechnicalService)
  getProductIncomingentity(){
    var params = {
      where: {product_id:this.product.id}
    };
    this.purchaseProductService.query(params).subscribe((purchaseProducts) =>{
      if (purchaseProducts.length > 0){
        this.purchase = purchaseProducts[0].purchase;
        if (this.purchase.createdBy){
          this.getUser(this.purchase)
        }
      }
    });
    this.repurchaseProductService.query(params).subscribe((repurchaseProducts) =>{
      if (repurchaseProducts.length > 0){
        this.repurchase = repurchaseProducts[0].repurchase;
        if (this.repurchase.createdBy){
          this.getUser(this.repurchase)
        }
      }
    });
    this.consignmentProductService.query(params).subscribe((consignmentProducts) =>{
      if (consignmentProducts.length > 0){
        this.consignment = consignmentProducts[0].consignment;
        if (this.consignment.createdBy){
          this.getUser(this.consignment)
        }
      }
    });
  }

  getUser(entity){
    this.userService.get(entity.createdBy).subscribe((user) =>{
      entity.createdBy = user;
    });
  }

  getProductCpus(){
    this.productCpuService.query({}).subscribe((productCpus) => {
      this.cpus = productCpus; 
    });
  }
  cpuSelected(e){
    this.product.cpu = e.name
  }

  getProductBrands(){
    this.productBrandService.query({}).subscribe((productBrands) => {
      this.brands = productBrands; 
    });
  }
  brandSelected(e){
    this.product.brand = e.name
  }

  getProductModels(){
    this.productModelService.query({}).subscribe((productModels) => {
      this.models = productModels; 
    });
  }
  modelSelected(e){
    this.product.model = e.name
  }

  getProductOperatingSystems(){
    this.productOperatingSystemService.query({}).subscribe((productOperatingSystems) => {
      this.operatingSystems = productOperatingSystems; 
    });
  }
  operatingSystemSelected(e){
    this.product.so = e.name
  }

  getProductStatuses(){
    this.productStatusService.query({}).subscribe((productStatuses) => {
      this.statuses = productStatuses; 
    });
  }
  productStatusesSelected(e){
    this.product.status = e.name
  }

  getProductStorageCapacities(){
    this.productStorageCapacityService.query({}).subscribe((productStorageCapacities) => {
      this.storageCapacities = productStorageCapacities; 
    });
  }
  storageCapacitiesSelected(e){
    this.product.storage_capacity = e.name
  }

  getProductTelephoneCompanies(){
    this.productTelephoneCompanyService.query({}).subscribe((productTelephoneCompanies) => {
      this.telephoneCompanies = productTelephoneCompanies; 
    });
  }
  telephoneCompanySelected(e){
    this.product.telephone_company = e.name
  }
  getProductRams(){
    this.productRamService.query({}).subscribe((productRams) => {
      this.rams = productRams; 
    });
  }
  ramSelected(e){
    this.product.ram = e.name
  }

  save(){
    if (   (this.productType === 1 && this.product.brand && this.product.model && this.product.storage_capacity && this.product.status && this.product.purchase_price && this.product.pin)
        || (this.productType === 2 && this.product.brand && this.product.model && this.product.storage_capacity && this.product.status && this.product.purchase_price)
        ||(this.productType === 4 && this.product.brand && this.product.model && this.product.so && this.product.status && this.product.serial_number  && this.product.cpu && this.product.ram && this.product.storage_capacity && this.product.purchase_price && this.product.pin)
         ||(this.productType === 3 && this.product.description )
        || (this.productType != 1 &&  this.productType != 2 &&  this.productType != 4 &&  this.productType != 3)){
      if ((this.product.imei && this.product.imei.length === 15 && this.product.type && this.product.sub_type === 1) || this.product.type !== 1 || this.product.sub_type !== 1){
        if (this.product.id == undefined){
          this.productService.create(this.returnProperties(this.product))
          .subscribe((person) => {
            this.getProduct();
            this.router.navigate(["/product/list/"])
          });
        }else{
          this.productService.update(this.returnProperties(this.product))
          .subscribe((person) => {
              this.getProduct();
              window.history.back();
          });
        }
      }else{
        alert("El imei debe contener 15 dígitos");
      }
    }else{
      alert("Falta por rellenar datos obligatorios");
    }
  }

  returnProperties(product){
    var properties = {
      type: product.type,
      sub_type: product.sub_type,
      brand: product.brand,
      model: product.model,
      storage_capacity: product.storage_capacity,
      status: product.status,
      serial_number: product.serial_number,
      charger: product.charger,
      case: product.case,
      original_box: product.original_box,
      description: product.description,
      purchase_price: product.purchase_price,
      sale_price: product.sale_price,
      stock: product.stock,
      telephone_company: product.telephone_company,
      imei: product.imei,
      imei2: product.imei2,
      accessories: product.accessories,
      so: product.so,
      cpu: product.cpu,
      ram: product.ram,
      pin: product.pin
    }
    if (product.id){
      properties['id'] = product.id;
    }
    return properties;
  }

  calculatePurchasePrice(){
    if (this.transactionType === 'consignment'){
      if (this.product.sale_price <= 2){
        this.product.purchase_price = Math.round((this.product.sale_price*0.5)*100)/100;
      }else{
        this.product.purchase_price = Math.round((this.product.sale_price*0.6)*100)/100;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/products/components/view-product/view-product.component.ts